import React, { useState, useEffect } from "react";
import ReactSelect from "react-select";
import Firebase from "../../firebasehelper";
import "./index.css";
import MediaSelect from "../MediaSelect";
import MediaContentViewer from "../MediaContentViewer";
import RadioItem from "../RadioItem";

function EditPoll(props) {
  const { currentPoll, onSave, brand_name } = props;
  const [poll, setPoll] = useState(currentPoll);
  const [uploading, setUploading] = useState(false);
  const [hotTopicTags, setHotTopicTags] = useState([]);
  const [uploadFolder, setUploadFolder] = useState("");

  useEffect(() => {
    setPoll(currentPoll);
  }, [currentPoll]);

  useEffect(() => {
    if (brand_name)
      Firebase.getAllHotTopics(brand_name, (hot_topics) => {
        let hot_topic_tags = hot_topics.map((topic) => {
          let label = `${topic.starting_monday
            .toDate()
            .toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
            })} - ${topic.tag}`;
          let value = topic.id;
          return { label, value };
        });
        setHotTopicTags(hot_topic_tags);
        setUploadFolder(`polls/${brand_name}`);
      });
    else {
    }
  }, []);

  const onChange = (e) => {
    // this.setState({ [e.target.name]: e.target.value });
  };

  const onAddAnswer = () => {
    let { answers } = poll;
    if (answers.length >= 12) {
      return;
    }
    answers = [
      ...answers,
      {
        text: "",
        icon: "",
      },
    ];
    const updatedPoll = { ...poll };
    updatedPoll.answers = answers;
    setPoll(updatedPoll);
  };

  const onChangeAnswer = (index) => (e) => {
    const { answers } = poll;
    answers[index].text = e.target.value;
    const updatedPoll = { ...poll };
    updatedPoll.answers = answers;
    setPoll(updatedPoll);
  };

  const onRemoveAnswer = (index) => () => {
    const { answers } = poll;
    answers.splice(index, 1);
    const updatedPoll = { ...poll };
    updatedPoll.answers = answers;
    setPoll(updatedPoll);
  };

  const handleMediaChanged = (type, url) => {
    // this.setState({ media_type: type, media_url: url });
    setPoll({ ...poll, media_type: type, media_url: url });
  };

  const isPostable = () => {
    // const {
    //   question,
    //   answers,
    //   media_type,
    //   media_url,
    //   scheduledDate,
    //   hot_topic,
    //   postNow,
    // } = this.state;
    // const timeValuable = postNow
    //   ? true
    //   : scheduledDate.isAfter(moment(new Date()));
    // const isPostable =
    //   question &&
    //   media_type &&
    //   media_url &&
    //   !answers.find((answer) => !answer.text) &&
    //   timeValuable;
    // return isPostable;
    return true;
  };

  return (
    <div className="new-poll-container">
      <div className="left-side">
        <p className="section-title">Poll Topic</p>
        <input
          type="text"
          name="question"
          className="form-control form-control-lg form-control-alt"
          onChange={onChange}
          value={poll.question}
          placeholder="Type your question here..."
        />
        <p className="section-title">Poll Media</p>
        <MediaSelect
          uploadFolder={uploadFolder}
          onChangeContent={handleMediaChanged}
          existingContent={{
            mediaType: poll.media_type,
            mediaUrl: poll.media_url,
          }}
        />
        {/* <button
            className="btn btn-hero-lg btn-hero-success poll-image-btn"
            onClick={this.openPollImage}
          >
            Choose Image
          </button> */}
        {/* <input
            type="file"
            id="quiz_img"
            name="logo-file-input"
            accept="image/*"
            onChange={this.selectedFile}
            style={{ display: "none" }}
          /> */}
        {poll.answers &&
          poll.answers.map(({ icon, text }, index) => (
            <div className="option" key={index}>
              <div className="answer-title">
                <p className="section-title">Answer {index + 1}</p>
                {poll.answers.length > 2 && (
                  <i
                    className="far fa-times-circle"
                    onClick={onRemoveAnswer(index)}
                    // disabled
                  ></i>
                )}
              </div>
              <input
                // disabled
                type="text"
                className="form-control form-control-lg form-control-alt"
                value={text}
                onChange={onChangeAnswer(index)}
                placeholder={`Type your answer ${index + 1}...`}
              />
            </div>
          ))}
        <button
          className="btn btn-secondary post"
          onClick={onAddAnswer}
          // disabled
        >
          Add another poll answer
        </button>
        <div className="user-access-categories">
          <p>Post to user access categories</p>
          <RadioItem
            menuName="Members"
            checked={poll.toMembers === true}
            onYes={() => {
              setPoll((prev) => ({ ...prev, toMembers: true }));
            }}
            onNo={() => {
              setPoll((prev) => ({ ...prev, toMembers: false }));
            }}
          />
          <RadioItem
            menuName="Prospect"
            checked={poll.toReferrals === true}
            onYes={() => {
              setPoll((prev) => ({ ...prev, toReferrals: true }));
            }}
            onNo={() => {
              setPoll((prev) => ({
                ...prev,
                toReferrals: false,
              }));
            }}
          />
        </div>
        {hotTopicTags.length > 0 && (
          <div className="form-group" style={{ marginTop: 30, width: 500 }}>
            <ReactSelect
              isDisabled={true}
              isSearchable={true}
              value={poll.hot_topic}
              onChange={(e) => {
                const { label, value } = e;
                // this.setState({ hot_topic: { label, value } });
              }}
              options={[{ label: "None", value: null }, ...hotTopicTags]}
              placeholder="Select a hot topic tag"
              styles={{
                option: (provided, state) => ({
                  ...provided,
                  textAlign: "left",
                }),
              }}
            ></ReactSelect>
          </div>
        )}
        {/* <p className="schedule-title">
          {!poll.selectedDate && (
            <React.Fragment>
              <b>Post now</b> or{" "}
            </React.Fragment>
          )}
          <b>Schedule</b>
        </p>
        {!poll.selectedDate && (
          <div className="schdule-now-container">
            <div
              className={classnames("check-box", {
                checked: poll.postNow,
              })}
              onClick={handlePostNowChanged(true)}
              style={{
                marginLeft: "20px",
              }}
            ></div>
            <div
              className={classnames("check-box", {
                checked: !poll.postNow,
              })}
              onClick={handlePostNowChanged(false)}
              style={{
                marginLeft: "80px",
              }}
            ></div>
          </div>
        )} */}
        {/* {!postNow && (
            <Datetime
              initialValue={this.props.selectedDate || moment()}
              initialViewMode={selectedDate ? "time" : "days"}
              onChange={this.onChangeScheduledDate}
              inputProps={{
                className:
                  "form-control form-control-lg form-control-alt date-input",
              }}
              dateFormat="DD/MM/YYYY"
            />
          )} */}
        {/* {!poll.postNow && !poll.selectedDate && (
          <DateTimePicker onTimeChange={onChangeScheduledDate} />
        )} */}
        {/* {poll.selectedDate && (
          <React.Fragment>
            <p className="feed-schedule-time">
              {poll.scheduledDate.format("LLL")}
            </p>
            <TimePicker onChange={onChangeTime} />
          </React.Fragment>
        )} */}
        {uploading && <i className="fa fa-4x fa-sync fa-spin text-muted" />}
        {!uploading && (
          <button
            className="btn btn-green post"
            disabled={!isPostable()}
            onClick={() => onSave(poll)}
          >
            Save
          </button>
        )}
      </div>
      <div className="right-side">
        {/* <div
          className="image-area"
          style={
            poll.media_url
              ? {
                  backgroundImage: `url(${poll.media_url})`,
                }
              : {}
          }
        ></div> */}
        <MediaContentViewer
          media_type={poll.media_type}
          media_url={poll.media_url}
        />
      </div>
    </div>
  );
}

export default EditPoll;



// WEBPACK FOOTER //
// ./src/components/EditPoll/index.js